import Autocomplete from "../common/Autocomplete";
import BannerMessage from "../common/BannerMessage";
import Checkbox from "../common/Checkbox";
import InputLabel from "../common/InputLabel";
import SimpleSelection from "../common/SimpleSelection";
import './index.css'


export default function UserForm({ userForm, profilesList, personsList, action = 'view',
  handleSelection, handleChange, handleCheck, errors = [] }: any) {

  return <>
    <div className="users-action-form">
      <div className="users-action-form-item">
        <InputLabel
          label='Nombre de Usuario'
          name='username'
          value={userForm.username}
          onChange={handleChange}
          required
          error={errors.includes('username') && userForm.username.length === 0}
          disabled={action === 'view'}
        />
      </div>

      <div className="users-action-form-item">
        <Autocomplete
          label='Persona'
          name='person'
          value={userForm.person}
          options={personsList}
          handleSelection={handleSelection}
          placeholder='Persona'
          disabled={action === 'view' || action === 'edit'}
          required
          error={errors.includes('person') && !userForm.person?.id}
          helperText='campo requerido'
        />
      </div>

      <div className="users-action-form-item">
        <SimpleSelection
          label='Perfil'
          name='profile'
          value={userForm.profile}
          options={profilesList}
          onChange={handleChange}
          disabled={action === 'view'}
        />
      </div>

      <div className="users-action-form-item">
        <Checkbox
          label='Habilitado'
          name='enabled'
          value={userForm.enabled === 'true'}
          handleChange={handleCheck}
          disabled={action === 'view'}
        />
      </div>

      {(action === 'view' || action === 'edit') && (<>

        <div className="users-action-form-item">
          <InputLabel
            label='Fecha de Creación'
            name='modified_date'
            value={userForm.created_date}
            disabled
            onChange={handleChange}
          />
        </div>

        <div className="users-action-form-item">
          <InputLabel
            label='Último Accesso'
            name='last_login'
            value={userForm.last_login}
            disabled
            onChange={handleChange}
          />
        </div>

      </>)}

      {(action === 'create') && (<>
        <BannerMessage
          message="Se enviará un email a la persona para crear su contraseña"
          type="info"
        />

      </>)}

    </div>
  </>
}